(() => {
  'use strict';
  const initialized = new WeakSet();
  const shownKey = 'nj:pbf:2026-11-09:shown';
  const elapsedKey = 'nj:pbf:2026-11-09:elapsed';
  const read = (storage, key) => {
    try { return Number(window[storage].getItem(key)) || 0; } catch (_) { return 0; }
  };
  const write = (storage, key, value) => {
    try { window[storage].setItem(key, String(value)); } catch (_) {}
  };
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const delay = Math.max(15, Number(root.dataset.delay) || 40) * 1000;
    const cooldown = Math.max(1, Number(root.dataset.frequency) || 24) * 3600000;
    const expires = root.dataset.expires ? Date.parse(root.dataset.expires) : Infinity;
    const expired = () => Number.isNaN(expires) || Date.now() >= expires;
    const seen = () => { const at = read('localStorage', shownKey); return at > 0 && Date.now() - at < cooldown; };
    if (expired() || seen()) return;
    let elapsed = Math.min(read('sessionStorage', elapsedKey), delay);
    let last = performance.now();
    let wasVisible = !document.hidden;
    let interval;
    let previousFocus;
    const cleanup = () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', tick);
      window.removeEventListener('pagehide', save);
      window.removeEventListener('storage', onStorage);
      document.removeEventListener('keydown', onKey);
    };
    const hide = () => {
      const restore = root.contains(document.activeElement);
      root.hidden = true;
      cleanup();
      if (restore && previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
    const busy = () => {
      if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return true;
      return [...document.querySelectorAll('cart-drawer[open],newsletter-popup[open],dialog[open],[role="dialog"][aria-modal="true"]')]
        .some(el => !el.hidden && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden');
    };
    const show = () => {
      if (expired() || seen()) { cleanup(); return; }
      if (document.hidden || busy()) return;
      previousFocus = document.activeElement;
      write('localStorage', shownKey, Date.now());
      elapsed = 0;
      write('sessionStorage', elapsedKey, elapsed);
      root.hidden = false;
      const announcement = root.querySelector('[data-nj-pbf-announcement]');
      if (announcement) announcement.textContent = announcement.dataset.message;
    };
    function tick() {
      const now = performance.now();
      if (expired() || !root.isConnected) { hide(); return; }
      if (!root.hidden) { if (busy()) hide(); return; }
      if (wasVisible) elapsed = Math.min(delay, elapsed + Math.max(0, Math.min(now - last, 1500)));
      wasVisible = !document.hidden;
      last = now;
      write('sessionStorage', elapsedKey, elapsed);
      if (elapsed >= delay && root.hidden) show();
    }
    function save() { tick(); write('sessionStorage', elapsedKey, elapsed); }
    function onStorage(event) { if (event.key === shownKey && seen()) hide(); }
    function onKey(event) { if (event.key === 'Escape' && !root.hidden) hide(); }
    root.querySelector('[data-nj-pbf-close]')?.addEventListener('click', hide);
    root.querySelectorAll('[data-nj-pbf-link]').forEach(link => link.addEventListener('click', hide));
    document.addEventListener('keydown', onKey);
    document.addEventListener('visibilitychange', tick);
    window.addEventListener('pagehide', save);
    window.addEventListener('storage', onStorage);
    interval = window.setInterval(tick, 1000);
    tick();
  }
  const scan = () => document.querySelectorAll('[data-nj-pbf]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
